import '../../Report.css'
import { ReportDirectionLevels } from '../../types/report.input.types'
import './DirectionItem.css'

export type DirectionItemProps = {
  index: number
  img: string
  title: string
  level: ReportDirectionLevels
}

const DirectionItem = (props: DirectionItemProps) => {
  const isLeftSide = ((props?.index || 1) - 1) % 2 === 0

  return (
    <div
      className='direction-item-card'
      style={{ flexDirection: isLeftSide ? 'row' : 'row-reverse' }}
    >
      <img
        src={props.img}
        alt='DIRECTIONS_ITEM_IMG'
        className='direction-item-img'
      />
      <div className='direction-item-card-inner'>
        <div className='num-dot-item'>{props.index}</div>
        <p
          className='title-bold'
          style={{ fontSize: '0.8rem', textTransform: 'capitalize', marginTop: 20 }}
        >
          {props.level.toLowerCase()}
        </p>
        <p
          style={{ fontSize: '0.8rem', color: '#212121', opacity: 0.6 }}
          className='direction-overflow-card-text'
        >
          {props.title}
        </p>
      </div>
      <div style={{ flex: 1 }}></div>
    </div>
  )
}

export default DirectionItem
